import { Box, CircularProgress } from '@mui/material';
import { SxProps, SystemStyleObject } from '@mui/system';
import { Styles } from 'common/types/styles';
import { ReactElement, ReactNode, forwardRef } from 'react';

interface StylesProps {
  loading: boolean;
}

const getStyles = ({ loading }: StylesProps): Styles => ({
  coverLoadingContainer: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    justifyContent: 'center',
    alignItems: 'center',
    top: 0,
    left: 0,
    zIndex: 10,
    pointerEvents: loading ? 'none' : 'auto',
    color: '#3B2FD7',
    fontSize: 18,
  },
  container: {
    filter: loading ? 'blur(8px)' : 'none',
    pointerEvents: loading ? 'none' : 'auto',
    transition: 'filter 0.3s ease',
    overflowX: 'scroll',
    position: 'relative',
    height: '100%',
    maxHeight: 'inherit',
  },
});

export interface CustomContainerProps {
  loading?: boolean;
  loadingText?: string;
  children: ReactNode;
  sx?: SystemStyleObject;
}

export const ContainerWithLoading = forwardRef<HTMLDivElement, CustomContainerProps>(function (
  { loading = false, loadingText, children, sx },
  ref
): ReactElement {
  const styles = getStyles({ loading });

  return (
    <>
      <Box ref={ref} sx={{ ...styles.container, ...sx } as SxProps}>
        {children}
      </Box>
      {loading && (
        <Box sx={styles.coverLoadingContainer}>
          <CircularProgress color="primary" />
          {loadingText && <p>{loadingText}</p>}
        </Box>
      )}
    </>
  );
});
